"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    dataDimension: true
};
//# sourceMappingURL=organisationUnitGroupSet.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2/lib/model/config/model-defaults/organisationUnitGroupSet.js
// module id = 594
// module chunks = 13